import { LabelName } from '@aibees/elephant/feature/label-management-table/components/label-name';
import { Label } from '@aibees/elephant/types/label';
import { TextEllipsis } from '@aibees/shared/components';
import { AdvanceTableConfig } from '@aibees/shared/features';
import { fHumanReadableNumber, userGetShortName } from '@aibees/shared/utils';
import { CardBodyTotalRecords } from '../../styles';
import { LabelSearchTableAction } from './actions/label-search-table-action';
import * as SX from './sx';

export const config: Omit<AdvanceTableConfig<Label>, 'browseApi'> = {
  columns: [
    {
      id: 'name',
      label: 'Name',
      sortable: 'name',
      width: 132,
      render: (_, v) => <LabelName item={v} />,
      align: 'left',
    },
    {
      id: 'records',
      label: 'Total Records',
      sortable: true,
      width: 70,
      render: (v) => (
        <CardBodyTotalRecords>{fHumanReadableNumber(v)}</CardBodyTotalRecords>
      ),
    },
    {
      id: 'workspace',
      label: 'Team',
      sortable: true,
      width: 56,
      render: (_, v) => (
        <TextEllipsis
          value={userGetShortName(v.workspace.user)}
          variant="body4"
          color="grey.700"
        />
      ),
    },
  ],
  actions: [LabelSearchTableAction],
  filters: [],
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  hidePagination: true,
  stickyHeader: true,
  hideColumnsOnNoData: true,
  defaultOrderBy: 'modified',
  emptyProps: {
    emptyIcon: 'label',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },
  hideResetFilters: true,
  cellSx: { p: 1 },
  bordered: 'solid',
};
